import React, { useEffect, useState } from "react";
import { Box, Typography, Avatar, Grid } from "@mui/material";
import imageone from "../images/kineticAdminPanelBg.png";
import NavigationTab from "../navigation";
import logo from '../images/kineticlogo1.png'; 

const HomePage: React.FC = () => {
    const [userName, setUserName] = useState("User");

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            try {
                const decodedToken = JSON.parse(atob(token.split(".")[1]));
                if (decodedToken.name) {
                    setUserName(decodedToken.name);
                }
            } catch (error) {
                console.error("Error decoding token:", error);
            }
        }
    }, []);

    return (
        <Box
            sx={{
                justifyContent: "center",
                alignItems: "center",
                height: "95vh",
                backgroundImage: `url(${imageone})`,
                backgroundPosition: "left center", 
                backgroundSize: "100%", 
                backgroundRepeat: "no-repeat",
                backgroundColor: "rgb(0, 0, 0)"
            }}
        >
            <NavigationTab />
            <Grid container>
                <Grid
                    item
                    xs={12}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "transparent",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            padding: "20px",
                            color: "white",
                            borderRadius: "16px", 
                            width: '70vw',
                        }}
                    >
                        <Typography variant="h4" sx={{ mb: 2 }}>
                            Welcome, {userName}
                        </Typography>
                        <Avatar
                            src={logo}
                            alt="Logo"
                            sx={{
                                width: 120,
                                height: 120,
                                mb: 2,
                                backgroundColor: "white",
                            }}
                        />
                        <Typography variant="h5" sx={{ mb: 2 }}>
                            Kinetic
                        </Typography>
                        <Typography variant="body1" sx={{ lineHeight: 1.5 }}>
                            Kinetic Green, today is a leading player in the Electric Vehicle space, offering a wide range of electric vehicles, including electric three-wheelers and two-wheelers. For electric golf-carts and buggies, the company has formed a Joint Venture with the world’s leading luxury brand, Tonino Lamborghini of Italy.
                            
                            Kinetic Green is Spearheaded by third generation scion of the Firodia family, Ms. Sulajja Firodia Motwani.
                            
                            The mission of Kinetic Green is to provide green mobility to the masses. Kinetic Green has had several firsts to its name, including being the first company to develop ARAI approved electric three-wheelers and the first to offer Lithium-ion battery technology in their electric three-wheelers in India.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default HomePage;